module.exports = __webpack_public_path__ + "img/lg.d97b6869.svg";